import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { listado_comunas} from '../../utils/Global';

const options = [];

for (let i = 0; i < listado_comunas.length; i++) {
    const element = listado_comunas[i];
    options.push({value:element.id,label:element.nombre})
}

export const Comunas = ({
    className,
    updateState,
    val=null
    }) => {

    const [valor, setvalor] = useState({value:val,label:val})

    useEffect(() => {
        const resultado = val ? options.find(item => item.value === val.toString()) : undefined;
        console.log('elvalor',val);
        if (resultado !== undefined) {
            setvalor(resultado)
        } else {
            setvalor({value:"",label:"-Seleccione una opción-"})
        }
       
    }, [val,options])
    

    const handleChange = ((e)=>{
        console.log(e);
        setvalor(e);
        updateState([
            {
              name: "comuna",
              value: e.value,
            },
        ])
    })

    return (
        <Select 
            classNamePrefix="select"
            name='calle'
            value={valor}
            onChange={handleChange}
            className={className} 
            options={options} />
    );
}
